import React from 'react'
import { Breadcrumb } from 'antd';
import { useHistory } from "react-router-dom";


function BreadCrumbNav({ items }) {
    const history = useHistory()
    
    const goHome = () => history.push("/")

    const navigate = (item) => {
        const path = item.split(" ").join("-").toLowerCase()
        history.push("/" + path)
    }

    return (
      <div className="hidden md:block pt-3 mx-4 mt-2">
        <Breadcrumb>
            <Breadcrumb.Item onClick={goHome}>
                <div className="inline-flex justify-start items-center cursor-pointer hover:text-purple-600">
                    <svg className="w-4 h-4 fill-current" viewBox="0 0 20 20"><path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path></svg>
                </div>
            </Breadcrumb.Item>
            
            {items.map((item, k) => (
                <Breadcrumb.Item key={k} onClick={() => navigate(item)}>
                    <span className="text-sm mt-1 cursor-pointer hover:text-purple-600">{item}</span>
                </Breadcrumb.Item>
            ))}

        </Breadcrumb>
      </div>
    );
  }
  
  export default BreadCrumbNav;
  